import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL_API + process.env.VUE_APP_VENDING_API

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {}, // do not remove this, its added to add params later in the config
})

const __urlThatDontGetAborted = ["reports", "P1D", "PT1H", "connectors", "preprocessing"]
/* Latest-Gets request management (per-path, ignoring query arguments). */
const __lastGetControllers = new Map()
const __lastGetSequence    = new Map()

// Reset maps on page reload/navigation or BFCache restore
if (typeof window !== 'undefined') {
  const resetLatestGets = () => {
    __lastGetControllers.clear()
    __lastGetSequence.clear()
  }
  window.addEventListener('beforeunload', resetLatestGets)
  window.addEventListener('pagehide', resetLatestGets) // Safari/iOS friendly
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) resetLatestGets() // BFCache restore
  })
}

function __lastGetNormalizeKey(action) { // removes the ?arguments=....
  if (typeof action !== 'string') return '';
  // 1) drop the query string
  let key = action.split('?')[0];
  // 2) replace any path segment that is purely digits
  //    e.g. '/items/123/details' → '/items/ANY_KEY/details'
  key = key.replaceAll(/\/\d+(?=\/|$)/g, '/ANY_KEY/');

  // (optionally) normalize trailing slash
  key = key.replace(/\/+$/, '');
  return key;
}

function __lastGetNextSequence(key) {
  const n = (__lastGetSequence.get(key) || 0) + 1
  __lastGetSequence.set(key, n)
  return n
}

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  /* global  Store */
  let token = Store.state.loggeduser.user.accessToken
  if (!config.headers) {
    config.headers = {}
  }
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

instance.interceptors.response.use((response) => {
  // Drop stale responses for latest GETs
  const key = response.config && response.config.__lastGetKey
  if (key) {
    const id = response.config.__lastGetId
    const current = __lastGetSequence.get(key)
    if (current && id !== current) {
      const err = new Error('canceled')
      err.code = 'ERR_CANCELED'
      return Promise.reject(err)
    }
  }
  return response
}, async (error) => {
  // ignore cancellations (manual AbortController or stale response drop)
  if (error && (error.code === 'ERR_CANCELED' || error.message === 'canceled')) {
    return Promise.reject(error)
  }
  try {
    this.$store.commit('global/set_snackbar', { display: true, mode: 'error', notice: 'Erreur lors de la récupération' })
  } catch (e) {
    // we do nothing
  }
  if (typeof error.response !== 'undefined' && error.response.status == 401 && window.location.hash.indexOf("login") < 0) {
    await Store.dispatch('loggeduser/logout');
    window.location.assign((process.env.BASE_URL ?? '') + "/#/login?redirect=" + window.location.hash.replace("#", ""));
  }
  return Promise.reject(error)
})

export default {
  getUrl(relativeURI) {
    return BASE_URL + relativeURI;
  },
  getData(action, config) {
    let url = `${BASE_URL}`
    url += action
    // latest-Gets per endpoint path (ignores query string)
    const key = __lastGetNormalizeKey(action)
    const skipAbort = __urlThatDontGetAborted.some(u => action.includes(u))
    let controller, lastGetId
    if (!skipAbort) {
      // abort previous in-flight GET for this key
      const prev = __lastGetControllers.get(key)
      if (prev && typeof prev.abort === 'function') {
        prev.abort();
      }
      // save this call
      controller = new AbortController()
      __lastGetControllers.set(key, controller)
      lastGetId = __lastGetNextSequence(key)
    }

    const cfg = { ...(config) }
    if (!skipAbort) {
      if (!cfg.signal) {
        cfg.signal = controller.signal
      }
      // attach metadata used by response interceptor to drop stale responses
      cfg.__lastGetKey = key
      cfg.__lastGetId = lastGetId
    }

    return instance.get(url, cfg)
  },
  postData(action, data, config) {
    let url = `${BASE_URL}`
    url += action
    return instance.post(url, data, config)
  },
  putData(action, data, config) {
    let url = `${BASE_URL}`
    url += action
    return instance.put(url, data, config)
  },
  deleteData(action, data, config) {
    let url = `${BASE_URL}`
    url += action
    return instance.delete(url, {...config, data: data})
  },
  login(action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.get(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
}
